// extracted by mini-css-extract-plugin
module.exports = {"bg_main_div":"DefaultLayout_bg_main_div__15HW0","bg_main_div2":"DefaultLayout_bg_main_div2__qAZcD","bg_container":"DefaultLayout_bg_container__Tq4KD"};